export default {
  barTitle: 'Cookies',
  barDescription:
    'Wir verwenden unsere eigenen Cookies und Cookies von Drittanbietern, damit wir Ihnen diese Website zeigen können und verstehen wie Sie diese verwenden, um die von uns angebotenen Dienstleistungen zu verbessern. Wenn Sie weiter surfen, gehen wir davon aus, dass Sie die Cookies akzeptiert haben.',
  acceptAll: 'Alle akzeptieren',
  declineAll: 'Alle ablehnen',
  manageCookies: 'Cookies verwalten',
  unsaved: 'Sie haben nicht gespeicherte Einstellungen',
  close: 'Schließen',
  save: 'Speichern',
  optional: 'Optionale Cookies',
  functional: 'Funktionale Cookies',
  blockedIframe:
    'Um den Inhalt zu sehen, aktivieren Sie bitte funktionale Cookies',
  here: 'hier',
  necessary: 'Notwendige Cookies'
}
